export const MANAGED_NEWSLETTER_CLOSE_TIME_LC_KEY = 'managed-newsletter-close-time'
